import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import type { ApiEndpoint, EntityItem } from "../../../types";
import DataItemDetails from "../../data-item-details/DataItemDetails";
import { useSelectedEntity } from "../../../hooks/useSelectedEntity";

const ReactivePopupContent: React.FC<{
  entityId: string | number;
  entityName: string;
  endpoint: ApiEndpoint;
  isLoading?: boolean;
  onBack: () => void;
  onFindRelated?: () => void;
}> = ({ entityId, entityName, endpoint, isLoading: externalLoading, onBack, onFindRelated }) => {
  const { entity: popupData, isLoading, isError } = useSelectedEntity();

  if (isLoading || !popupData) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          minWidth: 280,
          backgroundColor: "grey.600",
          height: 280,
          borderRadius: "0.5rem"
        }}
      >
        <Skeleton variant='rounded' height={"13em"} width='100%' />
        <Box sx={{ paddingInline: "1.5em", marginTop: "0.5em" }}>
          <Skeleton height={24} width='100%' sx={{ mb: "0.5em" }} />
          <Skeleton height={14} width='75%' />
          <Skeleton height={14} width='50%' />
          <Stack direction='row' alignItems='center' gap={"1.5em"} mt={"0.5em"}>
            <Skeleton height={48} width={"50%"} />
            <Skeleton height={36} width={36} variant='circular' />
            <Skeleton height={36} width={36} variant='circular' />
          </Stack>
        </Box>
      </Box>
    );
  }

  if (isError && !popupData) {
    return null;
  }

  return (
    <DataItemDetails
      item={popupData as EntityItem}
      onBack={onBack}
      dataDrawerEndpoint={endpoint}
      dataItemEndpoint={endpoint}
      availableHeight='auto'
      popupMode={true}
      onShowRelatedItems={onFindRelated}
    />
  );
};

export default React.memo(ReactivePopupContent);
